import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
// import { AutoComplete } from "primereact/autocomplete";
import { Calendar } from "primereact/calendar";
import * as Fa from "react-icons/fa";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Axios from "../../api/Axios";
import storage from "../../Services/Storage";
import { toast } from "react-toastify";
import { downloadExcel } from "../../Services/GlobalFunc/downloadExcel";
import { GetDateFormat } from "../../Services/GlobalFunc/DateFormat";

const url = "SGR/SGRBrandDataView/";
const GetSGR_url = `${url}GetQuarterSGR?`;
const GetPopulate_url = `${url}populateProduct?`;
const GetBlankgrid_url = `${url}populateGrid?`;
const GetExcel_url = `${url}GetExcelData?`;

const SGRBrandDataView = () => {
    const [isLBMBrandVisible, setIsLBMBrandVisible] = useState(false);
    const auth = storage.getLocal("user");
    //   const [quarterOptions, setQuarterOptions] = useState([]);
    const [quarters, setQuarters] = useState([]);
    const [selectedQuarter, setSelectedQuarter] = useState(null);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [maxQuarterDate, setMaxQuarterDate] = useState("");
    const [minQuarterDate, setMinQuarterDate] = useState("");
    const [blankGridData, setBlankGridData] = useState([]);
    const [lbmBrands, setLbmBrands] = useState([]);
    const [selectedLbmBrand, setSelectedLbmBrand] = useState(null);
    const [loadingExcel, setLoadingExcel] = useState(false);

    useEffect(() => {
        getSGRBrandOptions();
    }, []);

    // Function to get available Quarters
    const getSGRBrandOptions = async () => {
        try {
            const response = await Axios.get(`${GetSGR_url}UserId=${auth.UserId}`);
            //   setQuarters(response.data.Data);
            setQuarters(response.data.Data);
            setSelectedQuarter(response.data.Data[0]);
            handlechangeDateQuarter(response.data.Data[0]);
        } catch (error) {
            //showToastError();
        }
    };

    const getQuarterDates = (quarter, year) => {
        let startDate, endDate;
        const today = new Date();
        switch (quarter) {
        case 1:
            startDate = new Date(year, 0, 1);
            startDate.setSeconds(startDate.getSeconds() + 2);
            endDate = new Date(year, 2, 31);
            break;
        case 2:
            startDate = new Date(year, 3, 1);
            startDate.setSeconds(startDate.getSeconds() + 2);
            endDate = new Date(year, 5, 30);
            break;
        case 3:
            startDate = new Date(year, 6, 1);
            startDate.setSeconds(startDate.getSeconds() + 2);
            endDate = new Date(year, 8, 30);
            break;
        case 4:
            startDate = new Date(year, 9, 1);
            startDate.setSeconds(startDate.getSeconds() + 2);
            endDate = new Date(year, 11, 31);
            break;
        default:
            return null;
        }

        if (new Date(endDate).getTime() > new Date(today).getTime()) {
            endDate = new Date(today);
        }

        return { fromDate: startDate, toDate: endDate };
    };

    // Function to fetch LBM Brand based on Quarter & Dates
    const fetchLbmBrands = async () => {
        if (!selectedQuarter || !fromDate || !toDate) {
            toast.warn("Please select Quarter and Date Range!", {
                position: "top-center",
            });
            return;
        }

        try {
            const formattedFromDate = formatDate(fromDate);
            const formattedToDate = formatDate(toDate);

            const response = await Axios.get(
                `${GetPopulate_url}CompId=${auth.CompId}&strToDate=${formattedToDate}&strFromDate=${formattedFromDate}`
            );

            setLbmBrands(response.data.Data);
            setIsLBMBrandVisible(true); // Show the section only when data is fetched
        } catch (error) {
            //showToastError();
        }
    };

    // Helper function to format Date as "dd/mm/yyyy"
    const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);
        return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
            .toString()
            .padStart(2, "0")}/${d.getFullYear()}`;
    };

    // Error message function
    //   const //showToastError = () => {
    //     toast.error("Something went wrong. Please contact the helpdesk.", {
    //       position: "top-center",
    //       autoClose: 3000,
    //     });
    //   };

    const handlechangeDateQuarter = (value) => {
        // console.log(value);
        let value1 = value.QTR_DESC;
        setSelectedQuarter(value);
        let splitdata = value1.split(" ");
        let getquarter = splitdata[1].replace(",", "");
        let getyear = splitdata[2];
        let getquaterdata = getQuarterDates(parseInt(getquarter), getyear);
        setFromDate(getquaterdata.fromDate);
        setToDate(getquaterdata.toDate);
        setMinQuarterDate(getquaterdata.fromDate);
        setMaxQuarterDate(getquaterdata.toDate);
        setLbmBrands([]);
    };

    const fetchBlankGridData = async (selectedLbmBrand) => {
        if (!selectedQuarter || !fromDate || !toDate || !selectedLbmBrand) {
            toast.warn("Please select Quarter, Date Range, and LBM Brand!", {
                position: "top-center",
            });
            return;
        }

        try {
            const formattedFromDate = formatDate(fromDate);
            const formattedToDate = formatDate(toDate);
            const product = selectedLbmBrand?.LBM_BRAND_DESC;
            if (!product) {
                toast.warn("Invalid LBM Brand. Please select again!", {
                    position: "top-center",
                });
                return;
            }

            const BlankGrid_Url = `${GetBlankgrid_url}CompId=${auth.CompId}&strToDate=${formattedToDate}&strFromDate=${formattedFromDate}&Product=${product}`;

            const response = await Axios.get(BlankGrid_Url);

            if (response.data && response.data.length > 0) {
                setBlankGridData(response.data);
            } else {
                setBlankGridData([]);
                toast.warn("No data available for selected filters.", {
                    position: "top-center",
                });
            }
        } catch (error) {
            //showToastError();
        }
    };
    const QuarterTemplate = (quarter) => {
        return <>{quarter.QTR_DESC}</>;
    };

    const exportToExcel = async () => {
        try {
            if (!selectedQuarter || !fromDate || !toDate) {
                toast.warn("Please select Quarter and Date Range before exporting!", {
                    position: "top-center",
                });
                return;
            }

            const formattedFromDate = formatDate(fromDate);
            const formattedToDate = formatDate(toDate);
            setLoadingExcel(true);
            const excelUrl = `${GetExcel_url}CompId=${auth.CompId}&strToDate=${formattedToDate}&strFromDate=${formattedFromDate}`;
            const response = await Axios.get(excelUrl, { responseType: "json" });
            let uniqueNo = `SGRBrandView${GetDateFormat()}.xlsx`;
            if (response.data && response?.data?.length > 0) {
                downloadExcel(response.data, uniqueNo);
                // toast.success("Excel file downloaded successfully!", {
                //   position: "top-center",
                // });
            } else {
                toast.warn("No data available for export.", { position: "top-center" });
            }
        } catch (error) {
            console.error("Excel Export Error:", error);
            toast.error("Error exporting data. Please try again.", {
                position: "top-center",
            });
        } finally {
            setLoadingExcel(false);
        }
    };

    return (
        <>
            <div className="col-12 pt-3 pb-3">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">SGR Brand Data View</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="text-end mb-2">
                            <button
                                type="button"
                                title="View"
                                className="btn btn-primary"
                                onClick={fetchLbmBrands}
                            >
                View
                            </button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row">
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label className="form-label">Quarter</label>
                                {/* <Dropdown
                  value={selectedQuarter}
                  onChange={(e) => {
                    setSelectedQuarter(e.value);

                    // Check if the selected quarter is "Quarter 4, 2024"
                    if (e.value?.QTR_DESC === "Quarter 4, 2024") {
                      setFromDate(new Date(2024, 9 - 1, 1));
                      setToDate(new Date(2024, 12 - 1, 31));
                    }
                  }}
                  options={quarterOptions}
                  optionLabel="QTR_DESC"
                  placeholder="Select a Quarter"
                /> */}
                                <Dropdown
                                    inputId="queter"
                                    name="queter"
                                    value={selectedQuarter}
                                    onChange={(e) => handlechangeDateQuarter(e.value)}
                                    options={quarters}
                                    optionLabel="QTR_DESC"
                                    itemTemplate={QuarterTemplate}
                                />
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label className="form-label">From Date</label>
                                <Calendar
                                    showIcon
                                    value={fromDate}
                                    minDate={minQuarterDate}
                                    maxDate={maxQuarterDate}
                                    showMinMaxRange={true}
                                    dateFormat="dd/mm/yy"
                                    onChange={(e) => setFromDate(e.target.value)}
                                />
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label className="form-label">To Date</label>
                                <Calendar
                                    value={toDate}
                                    showIcon
                                    showMinMaxRange={true}
                                    dateFormat="dd/mm/yy"
                                    maxDate={maxQuarterDate}
                                    minDate={minQuarterDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                />
                            </div>
                        </div>
                    </form>
                </section>

                {isLBMBrandVisible && (
                    <section>
                        <div className="card">
                            <form>
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <label className="form-label">LBM Brand</label>
                                        {/* <Dropdown placeholder="Select LBM BRand" /> */}
                                        <Dropdown
                                            value={selectedLbmBrand}
                                            onChange={(e) => {
                                                setSelectedLbmBrand(e.value);
                                                fetchBlankGridData(e.value); // Fetch data on selection
                                            }}
                                            options={lbmBrands}
                                            optionLabel="LBM_BRAND_DESC"
                                            placeholder="Select LBM Brand"
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="text-end">
                                            <button
                                                type="button"
                                                title="View"
                                                className="btn btn-primary"
                                                onClick={exportToExcel}
                                                disabled={loadingExcel}
                                            >
                                                {loadingExcel ? "Loading..." : "Export To Excel"}{" "}
                                                {loadingExcel ? (
                                                    <span
                                                        className="spinner-border spinner-border-sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                ) : (
                                                    <Fa.FaFileExport className="ms-2" />
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <div className="col-md-12 col-lg-12 col-sm-12 mt-3">
                                <div className="DataTable">
                                    <DataTable
                                        value={blankGridData} // ✅ Bind fetched data here
                                        dataKey="CompId"
                                        paginator
                                        rows={10}
                                        showGridlines
                                        stripedRows
                                        scrollHeight="80vh"
                                        scrollable
                                        emptyMessage="No records found."
                                        rowsPerPageOptions={[10, 25, 50]}
                                    >
                                        <Column field="COMPANY_NAME" header="Company Name"></Column>
                                        <Column
                                            field="PercentageSD"
                                            header="TOTAL"
                                            className="text-end Right_Column"
                                        ></Column>
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </section>
                )}
            </div>
        </>
    );
};

export default SGRBrandDataView;
